import { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';

const LoginErrorTooltip = ({ errorType, tooltip, setIsRequired }) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const { t } = useTranslation();

    let errorText = '';

    if (errorType === 'usernameError' && tooltip.includes('emptyUsername')) {
        errorText = t('lbl_EnterUnameTip');
    }

    if (errorType === 'passwordError' && tooltip.includes('emptyPassword')) {
        errorText = t('lbl_EnterPwdTip');
    }

    if (!tooltip.includes('emptyUsername') && !tooltip.includes('emptyPassword')) {
        errorText = tooltip;
    }

    useEffect(() => {
        if (tooltip.length) {
            if (tooltip.includes('emptyUsername') && (errorType === 'usernameError')) {
                setIsTooltipOpen(true);
                setIsRequired(true);
            }

            if (tooltip.includes('emptyPassword') && (errorType === 'passwordError')) {
                setIsTooltipOpen(true);
                setIsRequired(true);
            }

            if (!tooltip.includes('emptyUsername')
                && !tooltip.includes('emptyPassword')
                && (errorType === 'passwordError')) {
                setIsTooltipOpen(true);
            }
        } else {
            setIsTooltipOpen(false);
        }
    }, [tooltip]);

    return (
        <div className="tooltip tooltip--bottom" data-open={isTooltipOpen}>
            <span className="c-text">{errorText}</span>
        </div>
    );
};

export default LoginErrorTooltip;
